import { Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { VatDeclarationsReportSection as VatDeclarationsReportSectionType } from '@features/vatDeclarations/types/vatDeclarationsReportSection'

import { HeadCell, HeadRow } from './styles'
import { TableBody } from './TableBody'

interface TableProps {
  reportSection: VatDeclarationsReportSectionType
  showTitle?: boolean
}

export const Table = ({ reportSection, showTitle = true }: TableProps): ReactElement => {
  const { t } = useTranslation()

  const hasTurnoverAmount = useMemo(
    () => reportSection.fields.some((field) => field.turnoverAmount !== undefined),
    [reportSection.fields],
  )
  const hasVatAmount = useMemo(
    () => reportSection.fields.some((field) => field.vatAmount !== undefined),
    [reportSection.fields],
  )
  const title = showTitle && reportSection.name ? reportSection.name : ''

  const hasBothAmounts = hasTurnoverAmount && hasVatAmount

  const getFourthColumnContent = () => {
    if (hasBothAmounts) {
      return <Text nowrap>{t('vat_declarations.report.subtitle.tax_due')}</Text>
    }
    if (hasTurnoverAmount) {
      return <Text nowrap>{t('vat_declarations.report.subtitle.tax_free')}</Text>
    }
    if (hasVatAmount) {
      return <Text nowrap>{t('vat_declarations.report.subtitle.tax_due')}</Text>
    }
    return null
  }

  return (
    <>
      <HeadRow>
        <HeadCell scope="col"></HeadCell>
        <HeadCell scope="col">
          <Text variant="bodyLG" weight="bold">
            {title}
          </Text>
        </HeadCell>
        <HeadCell scope="col">
          {hasBothAmounts && <Text nowrap>{t('vat_declarations.report.subtitle.tax_free')}</Text>}
        </HeadCell>
        <HeadCell scope="col">{getFourthColumnContent()}</HeadCell>
      </HeadRow>

      <TableBody tableRowsData={reportSection.fields} />
    </>
  )
}
